// Gratuity the selector offers: percentages min..max with quick-pick ticks.
export const gratuityConfig = {
  defaultPercent: 18,
  max: 30,
  min: 0,
  snapRadius: 0.5,
  step: 0.5,
  ticks: [15, 18, 20, 25]
} as const
